<template>
  <dialog-form
    class="recall-estimate"
    :show-dialog="isShowDialog"
    :is-available-submit="false"
    @cancel="hideDialog"
  >
    <template #title>
      Recall Estimates
    </template>

    <div class="initial-estimate">
      <div class="row">
        <div class="col-5">
          <span class="estimate-label">ETA</span>
          <span class="estimate-value">{{ estimationRide?.etaText }}</span>
        </div>
        <div class="col-5">
          <span class="estimate-label">Duration</span>
          <span class="estimate-value">{{ duration }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <span class="estimate-label">Distance</span>
          <span class="estimate-value">{{ distance }}</span>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-12">
          <span class="estimate-label">Estimate Range</span>
          <span class="estimate-value">{{ estimationRide?.estimate }}</span>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-6">
        <span class="estimate-label">Discount</span>
        <span class="estimate-value">{{ discount }}</span>
      </div>

      <div class="col-6">
        <span class="estimate-label">Plan</span>
        <span class="estimate-value">{{ selectedPlanMonthlyPrice ? `$${selectedPlanMonthlyPrice.toFixed(2)}` : '-' }}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <span class="estimate-label">Total</span>
        <span class="estimate-value">{{ estimateText }}</span>
      </div>
    </div>

    <template #cancel-button>
      Close
    </template>
  </dialog-form>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import {
  estimationRide,
  selectedPlanMonthlyPrice,
} from '@/use/registration';
import rideUtility from '@/Utils/rideUtility';

defineProps<{
  isShowDialog: boolean;
}>();
const emit = defineEmits(['cancel']);

const distance = computed(() => {
  if (!estimationRide.value?.distance) {
    return '-';
  }

  return `${estimationRide.value.distance?.toFixed(1)} mi`;
});

const duration = computed(() => {
  if (!estimationRide.value?.duration) {
    return '';
  }

  return `${estimationRide.value.duration} min(s)`;
});

const hasExpiringCreditsAttention = computed(
  () => estimationRide.value?.expiringCreditInfo?.minAmount && estimationRide.value?.expiringCreditInfo?.maxAmount,
);

const discount = computed(() => {
  if (!hasExpiringCreditsAttention.value) {
    return '-';
  }

  const { min, max } = rideUtility.getEffectiveCreditAmounts(estimationRide.value!.expiringCreditInfo);

  return min === max ? `$${min}` : `$${min} ~ $${max}`;
});

const estimateText = computed(() => rideUtility.getFinalEstimateTxt({
  rideEstimate: estimationRide.value,
  planCost: selectedPlanMonthlyPrice.value
}));

const hideDialog = () => {
  emit('cancel');
};
</script>

<style lang="scss" scoped>
.recall-estimate {
  .initial-estimate {
    padding: 10px;
    border: 1px solid #e5e5e5;
    background: #f1f1f1;
    border-radius: 5px;
  }

  .estimate-label {
    display: inline-block;
    text-transform: uppercase;
    min-width: 80px;
    padding-right: 10px;
  }

  .estimate-value {
    color: #0ab73f;
    font-weight: bold;
  }
}
</style>